// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"hospital"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M6 9V3H18V9H21V21H3V9H6Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M10 21V15H14V21H10Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10 8H12M12 8H14M12 8V6M12 8V10M10 15V21H14V15H10Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5 3C5.34388 3 5.67667 3 6 3M19 3C18.6561 3 18.3233 3 18 3M6 3V9C4.82099 9 4.52489 9 3 9V21H21V9C19.9327 9 18.9408 9 18 9V3M6 3C9.75964 3 14.2404 3 18 3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-hospital')
export default class HospitalIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hospital',
    }
  }
}
